import {
    getCurrentUserToken,
    getHasRememberedBetterAuthSessionUser,
    removeCurrentUserToken,
    removeRememberedBetterAuthSessionUser,
} from '../auth/authService';
import { clearCachedReduxState } from '../offline/cache/localCache';
import { selectHasAuthenticatedCurrentUser } from './currentUserSelector';

type FetchMeConfig = {
    withCredentials: true;
    skipAuthHeader: true;
};

type BetterAuthSessionDetails = {
    hasLegacyToken: boolean;
    hasRememberedBetterAuthSessionUser: boolean;
    hasHydratedCurrentUser: boolean;
};

export const getHasBetterAuthSession = ({
    hasLegacyToken,
    hasRememberedBetterAuthSessionUser,
    hasHydratedCurrentUser,
}: BetterAuthSessionDetails): boolean =>
    !hasLegacyToken && (hasRememberedBetterAuthSessionUser || hasHydratedCurrentUser);

export const getCurrentUserAuthSessionState = (
    state: unknown,
): {
    hasLegacyToken: boolean;
    hasBetterAuthSession: boolean;
} => {
    const hasLegacyToken = !!getCurrentUserToken();
    const hasRememberedBetterAuthSessionUser = getHasRememberedBetterAuthSessionUser();
    const hasHydratedCurrentUser = selectHasAuthenticatedCurrentUser(state);

    return {
        hasLegacyToken,
        hasBetterAuthSession: getHasBetterAuthSession({
            hasLegacyToken,
            hasRememberedBetterAuthSessionUser,
            hasHydratedCurrentUser,
        }),
    };
};

export const getFetchMeConfig = (hasBetterAuthSession: boolean): FetchMeConfig | undefined => {
    if (!hasBetterAuthSession) return undefined;

    return {
        withCredentials: true,
        skipAuthHeader: true,
    };
};

export const clearInvalidBetterAuthSession = async (): Promise<void> => {
    removeCurrentUserToken();
    removeRememberedBetterAuthSessionUser();
    await clearCachedReduxState();
};
